import { nextTick } from "vue";
import { useState } from "#imports";
function toggleAcordion(id, group) {
  const accordions = useState(
    "accordions",
    () => ({})
  );
  const accordion = accordions.value[group || id];
  accordions.value[group || id] = {
    isOpen: !accordion?.isOpen,
    openAccordion: accordion?.openAccordion === id ? null : id
  };
}
const getAccordions = () => {
  const accordions = useState("accordions", () => ({}));
  return accordions;
};
function toggleDrawer(name) {
  const drawers = useState("drawers", () => ({}));
  const drawer = drawers.value[name];
  drawers.value[name] = {
    isOpen: !drawer?.isOpen
  };
}
const getDrawers = () => {
  const drawers = useState("drawers", () => ({}));
  return drawers;
};
function toggleModal(name) {
  const modals = useState("modals", () => ({}));
  const drawer = modals.value[name];
  modals.value[name] = {
    isOpen: !drawer?.isOpen
  };
}
const getModals = () => {
  const modals = useState("modals", () => ({}));
  return modals;
};
async function jumpTo(selector, offsetValue) {
  let offset = 0;
  let element;
  const headerElement = document.querySelector(".nk-header");
  if (typeof selector === "object") {
    element = selector;
  } else {
    element = document.querySelector(selector);
  }
  if (!element)
    return;
  if (offsetValue) {
    offset = offsetValue;
  } else if (headerElement) {
    offset = headerElement.clientHeight;
  }
  const elementPosition = element.getBoundingClientRect().top - offset;
  window.scrollBy({
    top: elementPosition,
    behavior: "smooth"
  });
  await nextTick();
  if (typeof element.focus === "function") {
    element.focus();
  }
}
function slugify(value) {
  return value.toLowerCase().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
}
export {
  getAccordions,
  toggleAcordion,
  getDrawers,
  toggleDrawer,
  toggleModal,
  getModals,
  jumpTo,
  slugify
};
